import { render, staticRenderFns } from "./VMCSidebarCMS.vue?vue&type=template&id=074e0190&scoped=true"
import script from "./VMCSidebarCMS.vue?vue&type=script&lang=js"
export * from "./VMCSidebarCMS.vue?vue&type=script&lang=js"
import style0 from "./VMCSidebarCMS.vue?vue&type=style&index=0&id=074e0190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074e0190",
  null
  
)

export default component.exports